import { makeUsd, ProtocolKey, USD_ZERO } from '@silo/types';
import { Rewards, UnstyledLink } from '@silo/ui';
import { PATH } from 'app/hooks/useRoute';
import { useQueryProtocolRevenueBalanceUsd } from 'app/queries/use-query-revenue-data';
import { useQueryRewardsData } from 'app/queries/use-query-rewards-data';

interface DesktopRewardsTriggerProps {
  protocolKey: ProtocolKey;
}

export function DesktopRewardsTrigger({ protocolKey }: DesktopRewardsTriggerProps): JSX.Element | null {
  const { data } = useQueryRewardsData();
  const revenueBalanceUsd = useQueryProtocolRevenueBalanceUsd();

  const totalRewardsUsd = makeUsd((data?.data.totalRewardsUsd ?? USD_ZERO) + revenueBalanceUsd);

  if (totalRewardsUsd === 0n) {
    return null;
  }

  return (
    <UnstyledLink href={PATH.DASHBOARD} className={Rewards.trigger()}>
      <Rewards.TriggerContent protocolKey={protocolKey} totalRewardsUsd={totalRewardsUsd} />
    </UnstyledLink>
  );
}
